<script>
import cloneDeep from 'lodash/cloneDeep'
import { uniqBy } from 'lodash'
import productMixin from '@src/mixins/product'
export default {
  components: {},
  mixins: [productMixin],
  props: {
    products: {
      type: Array,
      required: true,
    },
    category: {
      type: Array,
      required: true,
    },
    prices: {
      type: Array,
      required: true,
    },
    defaultValue: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      pricesDialogVisible: false,
      filterCategoryPrices: [],
      catchPrices: [],
      catchBonusPrices: [],
      checkPrimaryAll: false,
      checkBonusAll: false,
      priceIndex: 0,
      bonusPriceIndex: 0,
      productSearch: '',
      priceSearch: '',
      currentPrice: {},
      checkPrimaryProductsIdsAll: false,
      checkBonusProductsIdsAll: false,
      selectServiceType: 'primary',
      modifiedMaxTimes: {
        primary: {}, 
        bonus: {} 
      }
      // isProductIdsIndeterminate: false,
      // submitData: this.defaultValue,
    }
  },
  computed: {
    submitData: {
      get() {
        return this.defaultValue
      },
      set(value) {
        this.$emit('update:defaultValue', value)
      },
    },
    filterPrices() {
      let list = []
      if (this.priceSearch) {
        list = this.filterCategoryPrices.filter((item) => {
          return item.title.search(this.priceSearch) !== -1
        })
      } else {
        list = this.filterCategoryPrices
      }
      list = list.map((item) => {
        return {
          title: item.title,
          serviceId: item.id,
          maxTimes: 1,
          productIds: [],
        }
      })
      return list
    },
    cloneFilterCategoryPrices() {
      return this.filterCategoryPrices.map((item) => {
        return {
          title: item.title,
          serviceId: item.id,
          maxTimes: 1,
          productIds: [],
        }
      })
    },
    filterProducts() {
      let list = []
      if (this.productSearch) {
        list = this.products.filter((item) => {
          return item.name.search(this.productSearch) !== -1
        })
      } else {
        list = this.products
      }
      return list
    },
    isProductIdsIndeterminate() {
      if (this.submitData.prices.length) {
        this.checkProductsIdsAll = this.submitData.prices[this.priceIndex].productIds.length === this.filterProducts.length
        if (this.submitData.prices[this.priceIndex].productIds.length === 0) return false
        return this.submitData.prices[this.priceIndex].productIds.length > 0 && this.submitData.prices[this.priceIndex].productIds.length < this.filterProducts.length
      } else {
        return true
      }
    },
    isIndeterminate() {
      const targetPrices = this.selectServiceType === 'primary' ? this.catchPrices : this.catchBonusPrices

      if (!targetPrices.length) return false
      if (targetPrices.length && this.priceSearch) {
        const filterPricesId = this.filterPrices.map((item) => item.serviceId)
        const result = filterPricesId.every((item) => targetPrices.includes(item))
        return !result
      }
      return targetPrices.length && targetPrices.length < this.filterPrices.length
    },
    isEditMode() {
      return !!this.defaultValue.groupOrdering
    },
  },

  created() {
    if (this.isEditMode) {
      this.getDefaultPrices()
    }
    this.getFilterCategoryPrices()
    this.servicesCheckedStatus()
  },
  methods: {
    createAvailable(type) {
      this.selectServiceType = type
      this.pricesDialogVisible = true
    },
    selectAvailable(index, type) {
      this.selectServiceType = type
      if (this.selectServiceType === 'primary') {
        this.priceIndex = index
      } else {
        this.bonusPriceIndex = index
      }

      this.setCurrentPrices()
    },
    setCurrentPrices() {
      const index = this.selectServiceType === 'primary' ? this.priceIndex : this.bonusPriceIndex
      const targetPrices = this.selectServiceType === 'primary' ? this.catchPrices : this.catchBonusPrices
      const price = this.filterCategoryPrices.find((item) => item.id === targetPrices[index])

      this.currentPrice = price
    },
    getFilterCategoryPrices() {
      const prices = this.prices
      if (this.defaultValue.categoryId) {
        const filterPrices = prices.filter((item) => {
          return item.petCategoryId === this.defaultValue.categoryId
        })
        this.filterCategoryPrices = filterPrices
      } else {
        this.filterCategoryPrices = prices
      }
    },
    getDefaultPrices() {
      this.catchPrices = this.submitData.prices.map((item) => item.serviceId)
      this.catchBonusPrices = this.submitData.bonusPrices.map((item) => item.serviceId)
      this.setCurrentPrices(this.selectContent === 'primary' ? this.priceIndex : this.bonusPriceIndex)
    },
    saveSelectPrices() {
      const isPrimary = this.selectServiceType === 'primary';
      
      const targetPrices = isPrimary ? this.submitData.prices : this.submitData.bonusPrices;
      const catchPrices = isPrimary ? this.catchPrices : this.catchBonusPrices;

      const newPrices = [];

      const havePriceIds = targetPrices.map(item => item.serviceId);
      // catchPrices後來要新增的
      // havePriceIds 現存已有的

      catchPrices.forEach((serviceId) => {
        const index = havePriceIds.indexOf(serviceId);
        
        // 如果服務已經在 targetPrices 中，更新其 maxTimes 值
        if (index !== -1) {
          const updatedService = {
            ...targetPrices[index], // 取出已經存在的服務項目
            maxTimes: this.modifiedMaxTimes[isPrimary ? 'primary' : 'bonus'][serviceId] || targetPrices[index].maxTimes
          };
          newPrices.push(updatedService);
        } else {
          // 如果服務不在 targetPrices 中，則新增這個服務
          const newService = this.filterPrices.find((item) => item.serviceId === serviceId);
          if (newService) {
            const addedService = {
              ...newService,
              maxTimes: this.modifiedMaxTimes[isPrimary ? 'primary' : 'bonus'][serviceId] || newService.maxTimes
            };
            newPrices.push(addedService);
          }
        }
      });

      const newPricesId = uniqBy(newPrices, 'serviceId');

      if (isPrimary) {
        this.submitData.prices = newPricesId;
      } else {
        this.submitData.bonusPrices = newPricesId;
      }

      this.pricesDialogVisible = false;

      if (targetPrices.length === 1) {
        this.priceIndex = 0;
      }
    },
    cancelSelectPrices() {
      this.catchPrices = this.submitData.prices.map((item) => item.serviceId).filter((id) => id)
      this.catchBonusPrices = this.submitData.bonusPrices?.map((item) => item.serviceId).filter((id) => id)

      this.pricesDialogVisible = false
    },
    handleCheckAllChange(checked) {
      const priceIds = this.filterPrices.map((item) => item.serviceId)
      let targetPrices = this.selectServiceType === 'primary' ? this.catchPrices : this.catchBonusPrices

      if (checked) {
        targetPrices = this.priceSearch.length ? [...targetPrices, ...priceIds] : [...priceIds]
      } else {
        targetPrices = this.priceSearch.length ? targetPrices.filter((item) => !priceIds.includes(item)) : []
      }

      if (this.selectServiceType === 'primary') {
        this.catchPrices = targetPrices
        return
      }
      this.catchBonusPrices = targetPrices
    },
    handleCheckProductIdsAllChange(serviceType, checked) {
      let disableContent = [];
      const permissionObj = this.$store.state.auth.currentUserPermission;

      if (serviceType === 'primary' && !permissionObj.isStoreAdmin) {
        this.checkPrimaryProductsIdsAll = checked;
        this.submitData.prices[this.priceIndex].productIds = checked ? [...this.filterProducts.map((item) => item.id)] : [];
        disableContent = this.findNotIncludePermission(this.submitData.prices[this.priceIndex].productIds);
      } else if (serviceType === 'bonus' && !permissionObj.isStoreAdmin) {
        this.checkBonusProductsIdsAll = checked;
        this.submitData.bonusPrices[this.bonusPriceIndex].productIds = checked ? [...this.filterProducts.map((item) => item.id)] : [];
        disableContent = this.findNotIncludePermission(this.submitData.bonusPrices[this.bonusPriceIndex].productIds);
      }

      // 如果是選中狀態，則將所有可選的產品加上，並包含權限過濾後的產品
      if (checked) {
        if (serviceType === 'primary') {
          this.submitData.prices[this.priceIndex].productIds = [
            ...this.filterProductInMixin(this.filterProducts).map((item) => item.id),
            ...disableContent,
          ];
        } else if (serviceType === 'bonus') {
          this.submitData.bonusPrices[this.bonusPriceIndex].productIds = [
            ...this.filterProductInMixin(this.filterProducts).map((item) => item.id),
            ...disableContent,
          ];
        }
      } else {
        // 如果是取消選中狀態，只保留權限過濾後的產品
        if (serviceType === 'primary') {
          this.submitData.prices[this.priceIndex].productIds = [...disableContent];
        } else if (serviceType === 'bonus') {
          this.submitData.bonusPrices[this.bonusPriceIndex].productIds = [...disableContent];
        }
      }
    },
    checkBoxStatus() {
      const selectPrimaryContent = this.submitData.prices[this.priceIndex].productIds
      const selectBonusContent = this.submitData.prices[this.bonusPriceIndex].productIds

      // const disableContent = this.findNotIncludePermission(this.submitData.prices[this.priceIndex].productIds)
      const allContent = this.filterProductInMixin(this.filterProducts).map((item) => item.id)

      this.checkPrimaryAll = allContent.every((item) => selectPrimaryContent.includes(item))
      this.checkBonusAll = allContent.every((item) => selectBonusContent.includes(item))
    },
    changeProductIds(value) {
      this.submitData.prices.forEach((price) => {
        price.productIds = [value]
      })
      this.submitData.bonusPrices.forEach((price) => {
        price.productIds = [value]
      })
    },
    removeAvailable(type, index) {
      this.selectServiceType = type
      const isPrimary = this.selectServiceType === 'primary'

      if (isPrimary) {
        this.submitData.prices.splice(index, 1)
        this.catchPrices.splice(index, 1)
      } else {
        this.submitData.bonusPrices.splice(index, 1)
        this.catchBonusPrices.splice(index, 1)
      }
      if (this.currentPrice) {
        let index = -1
        if (isPrimary) {
          index = this.catchPrices.indexOf(this.currentPrice.id)
        } else {
          index = this.catchBonusPrices.indexOf(this.currentPrice.id)
        }
        this.priceIndex = index !== -1 ? index : null
      }
    },
    changeCheckboxValue() {
      const filterPricesId = this.filterPrices.map((item) => item.serviceId)
      const currentSelectPrices = this.selectServiceType === 'primary' ? this.catchPrices : this.catchBonusPrices

      if (currentSelectPrices.length && this.priceSearch) {
        if (this.selectServiceType === 'primary') {
          this.checkPrimaryAll = filterPricesId.every((item) => this.catchPrices.includes(item))
          return
        }
        this.checkBonusAll = filterPricesId.every((item) => this.catchPrices.includes(item))
      }
    },
    isCheckboxActive(type, id) {
      if (!this.currentPrice) {
        return false
      }
      if (type === this.selectServiceType) {
        return this.currentPrice.id === id
      }
      return false
    },
    servicesCheckedStatus() {
      this.checkPrimaryAll = this.submitData.prices.length === this.filterCategoryPrices.length
      this.checkBonusAll = this.submitData.bonusPrices.length === this.filterCategoryPrices.length
    },
  },
}
</script>

<template>
  <div :class="$style.pageContent">
    <div class="isStylePageContent">
      <h4 class="form-block-title">適用項目</h4>
      <el-row :gutter="20">
        <el-col :md="12" :span="24">
          <h6 class="fw-regular text-text">購買項目(可複選)</h6>
          <div class="availableBg">
            <div :class="$style.box">
              <template v-if="submitData.prices.length && submitData.prices[0].title">
                <el-button
                  v-for="(primaryItem, index) in submitData.prices"
                  :key="index"
                  :class="{ isActiveCheckbox: isCheckboxActive('primary', primaryItem.serviceId) }"
                  class="is-round is-fullwidth bg-white isStyleAvailable"
                  @click="selectAvailable(index, 'primary')"
                >
                  <div class="text-left">
                    <div class="box__title d-flex justify-content-between w-100">
                      <span class="mr-2 align-self-center">{{ primaryItem.title }} </span>
                      <el-button type="text" size="mini" class="ml-auto" @click.stop="removeAvailable('primary', index)">
                        <BaseIcon name="times" />
                      </el-button>
                    </div>
                    <div class="d-flex align-items-center mt-3">
                      <el-input v-model.number="primaryItem.maxTimes" class="w-100 isStyleBase mr-3"></el-input>
                      <span class="align-self-center">次</span>
                    </div>
                  </div>
                </el-button>
              </template>
              <el-button class="is-round is-fullwidth" @click="createAvailable('primary')"> <BaseIcon name="plus" /> 選取適用服務 </el-button>
            </div>
          </div>
          <!-- 包月贈送功能(施工中) -->
          <h6 class="fw-regular text-text mt-4">贈送項目(可複選)</h6>
          <div class="availableBg">
            <div :class="$style.box">
              <template v-if="submitData.bonusPrices.length && submitData.bonusPrices[0].title">
                <el-button
                  v-for="(bonusItem, index) in submitData.bonusPrices"
                  :key="index"
                  :class="{ isActiveCheckbox: isCheckboxActive('bonus', bonusItem.serviceId) }"
                  class="is-round is-fullwidth bg-white isStyleAvailable"
                  @click="selectAvailable(index, 'bonus')"
                >
                  <div class="text-left">
                    <div class="box__title d-flex justify-content-between w-100">
                      <span class="mr-2 align-self-center">{{ bonusItem.title }} </span>
                      <el-button type="text" size="mini" class="ml-auto" @click.stop="removeAvailable('bonus', index)">
                        <BaseIcon name="times" />
                      </el-button>
                    </div>
                    <div class="d-flex align-items-center mt-3">
                      <el-input v-model.number="bonusItem.maxTimes" class="w-100 isStyleBase mr-3"></el-input>
                      <span class="align-self-center">次</span>
                    </div>
                  </div>
                </el-button>
              </template>
              <el-button class="is-round is-fullwidth" @click="createAvailable('bonus')"> <BaseIcon name="plus" /> 選取適用服務 </el-button>
            </div>
          </div>
        </el-col>
        <el-col :md="12" :span="24" class="store-block">
          <h6 class="fw-regular text-text">適用店家(可複選)</h6>
          <div class="availableBg">
            <div :class="[$style.box]">
              <template v-if="priceIndex !== null">
                <el-input v-model="productSearch" placeholder="搜尋" class="search-in-box">
                  <BaseIcon slot="suffix" name="search" class="el-input__icon" />
                </el-input>
                <div v-if="filterProducts.length" :class="$style['services-wrap']">
                  <template v-if="selectServiceType === 'primary' && submitData.prices.length">
                  <el-checkbox v-model="checkPrimaryProductsIdsAll" class="check-all" :indeterminate="isProductIdsIndeterminate" :disabled="!!productSearch" @change="handleCheckProductIdsAllChange('primary', $event)">
                    全選
                  </el-checkbox>
                    <el-checkbox-group v-model="submitData.prices[priceIndex].productIds" :class="$style.services">
                      <el-checkbox v-for="(store, index) in filterProducts" :key="index" :label="store.id" :disabled="disableComputed(store.id)" border @change="checkBoxStatus">
                        {{ store.name }}
                      </el-checkbox>
                    </el-checkbox-group>
                  </template>
                  <template v-else-if="selectServiceType === 'bonus' && submitData.bonusPrices.length">
                    <el-checkbox v-model="checkBonusProductsIdsAll" class="check-all" :indeterminate="isProductIdsIndeterminate" :disabled="!!productSearch" @change="handleCheckProductIdsAllChange('bonus', $event)">
                    全選
                  </el-checkbox>
                    <el-checkbox-group v-model="submitData.bonusPrices[bonusPriceIndex].productIds" :class="$style.services">
                      <el-checkbox v-for="(store, index) in filterProducts" :key="index" :label="store.id" :disabled="disableComputed(store.id)" border @change="checkBoxStatus">
                        {{ store.name }}
                      </el-checkbox>
                    </el-checkbox-group>
                  </template>
                  <template v-else>
                    <span class="mt-3 d-flex justify-content-center">請先選擇服務項目</span>
                  </template>
                </div>
              </template>
              <span v-else>請先選擇服務項目</span>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <el-dialog title="選取適用服務" :visible.sync="pricesDialogVisible" width="80%" top="0" append-to-body destroy-on-close @close="cancelSelectPrices">
      <el-form label-position="top" class="isWrap">
        <el-form-item>
          <el-input v-model="priceSearch" placeholder="搜尋" class="search-in-box">
            <BaseIcon slot="suffix" name="search" class="el-input__icon" />
          </el-input>
        </el-form-item>
        <el-form-item style="min-height: 250px" :class="$style['services-wrap']">
          <template>
            <el-checkbox v-if="selectServiceType === 'primary'" v-model="checkPrimaryAll" :indeterminate="isIndeterminate" class="check-all" border @change="handleCheckAllChange">
              全選
            </el-checkbox>
            <el-checkbox v-else v-model="checkBonusAll" :indeterminate="isIndeterminate" class="check-all" border @change="handleCheckAllChange">
              全選
            </el-checkbox>
          </template>
          <template v-if="selectServiceType === 'primary'">
            <el-checkbox-group v-model="catchPrices" :class="$style.services">
              <el-row :gutter="20">
                <template v-for="(price, index) in filterPrices">
                  <el-col :key="index" :md="12" :span="24">
                    <el-checkbox :label="price.serviceId" border @change="changeCheckboxValue">
                      {{ price.title }}
                    </el-checkbox>
                  </el-col>
                </template>
              </el-row>
            </el-checkbox-group>
          </template>
          <template v-else>
            <el-checkbox-group v-model="catchBonusPrices" :class="$style.services">
              <el-row :gutter="20">
                <template v-for="(price, index) in filterPrices">
                  <el-col :key="index" :md="12" :span="24">
                    <el-checkbox :label="price.serviceId" border @change="changeCheckboxValue">
                      {{ price.title }}
                    </el-checkbox>
                  </el-col>
                </template>
              </el-row>
            </el-checkbox-group>
          </template>
        </el-form-item>
      </el-form>

      <div class="btn-group-inline">
        <el-button class="is-round" @click="cancelSelectPrices">取消</el-button>
        <el-button class="is-round" type="primary" @click="saveSelectPrices">儲存</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<style lang="scss" module>
@import '@src/design/layout_detail_steps.scss';

:global {
  // 包月贈送樣式(施工中)
  .store-block {
    height: 982px;

    .availableBg {
      height: 947px;
    }
  }

  @media (max-width: 992px) {
    .store-block {
      height: auto;

      .availableBg {
        height: auto;
      }
    }
  }

  .availableBg {
    padding: 1.42rem;
    background: $color-line;
    border-radius: 8px;
    height: 450px;
    overflow: auto;
  }

  .isWrap {
    // .el-checkbox-group {
    //   display: flex;
    //   flex-wrap: wrap;
    // }
    .el-checkbox.is-bordered {
      // background-color: #fff;
      .el-checkbox__label {
        white-space: normal;
      }
    }
  }
}

.box {
  background-color: #f9f9f9;
  // border: $color-border-base 1px solid;
  padding: 15px;
  border-radius: 6px;

  :global {
    .box {
      &__title {
        white-space: normal;
        // text-align: left;
        line-height: 1.4;
        // max-width: calc(100% - 100px);
      }
    }

    .el-button {
      &.isStyleAvailable {
        height: auto;
        padding: 18px;

        &.isActiveCheckbox {
          color: initial;
        }
      }
    }

    .el-checkbox-group {
      // display: flex;
      // flex-wrap: wrap;
    }

    .el-checkbox.is-bordered {
      background-color: #fff;

      .el-checkbox__label {
        white-space: normal;
      }
    }

    .search-in-box {
      width: 100%;
      margin-bottom: 10px;
      // .el-input__inner {
      //   background-color: #fff;
      //   margin-left: 5px;
      //   margin-right: 5px;
      //   margin-bottom: 10px;
      // }
    }

    .input-in-buttom {
      display: flex;
      width: 100%;
      align-items: center;
    }

    .el-form-item {
      margin-bottom: 15px;
    }

    .el-button {
      // .el-input {
      //   width: 100px;
      // }
      .el-input__inner {
        background-color: #fff;
        // border-color: $color-border-base;
        height: 44px;

        &:focus {
          // border-color: $color-primary;
        }
      }

      .el-input__suffix {
        top: 7px;
      }
    }

    .inline-section {
      display: flex;
      margin-bottom: 15px;
    }

    .el-button.is-no-border {
      border: 0;
    }
  }

  &.right {
  }
}

.services-wrap {
  // margin: 0 -5px 30px;
  border: 1px solid $color-line-dark;
  border-radius: 8px;
  overflow: hidden;
  padding-bottom: 14px;
  margin-bottom: 2rem;
  background: #fff;

  :global {
    .check-all {
      display: block;
      background: $color-line;
      // border-color: $color-line;
      border: none;
      height: 40px;
      padding: 12px 18px 10px;

      .el-checkbox__label {
        color: $color-text-light;
      }
    }
  }
}

.services {
  padding: 0px 18px;
  border-top: 1px solid $color-line;
  display: block;

  :global {
    label.el-checkbox.is-bordered {
      // width: calc(50% - 10px);
      display: flex;
      width: 100%;
      margin-top: 14px;
      align-items: center;
      height: auto;
      padding: 15px 20px 15px 15px;
      margin-left: 0;
      margin-right: 0;
      // @include max-sm {
      //   width: 100%;
      // }

      .el-checkbox__inner {
        // border-radius: 2px;
        &:after {
          // left: 5px;
          // top: 2px;
          // height: 8px;
          // width: 4px;
          // border-width: 2px;
        }
      }

      .el-checkbox__label {
        width: 100%;
        overflow: auto;
        white-space: nowrap;
      }

      & + .el-checkbox.is-bordered {
        margin-left: 0;
      }

      .title,
      .meta {
        width: calc(100% - 20px);
        overflow: hidden;
        text-overflow: ellipsis;
        display: block;
      }

      .content {
        width: 100%;
      }
    }

    label.el-radio.is-bordered {
      // width: calc(50% - 10px);
      width: 98%;
      display: inline-flex;
      margin: 5px;
      align-items: center;
      height: auto;
      padding: 15px 20px 15px 15px;
      margin-top: 14px;
      border-radius: 8px;

      @include max-sm {
        width: 100%;
      }

      .el-radio__label {
        padding-left: 15px;
        width: 100%;
        overflow-x: auto;
        white-space: nowrap;
        line-height: 20px;
      }

      & + .el-radio.is-bordered {
        margin-left: 5px;
      }

      .title,
      .meta {
        width: calc(100% - 20px);
        overflow: hidden;
        text-overflow: ellipsis;
        display: block;
      }

      .content {
        width: 100%;
      }
    }
  }
}
</style>
